import type { ApplicantCreation } from 'cpool-schemas';
import { useFormContext, useWatch } from 'react-hook-form';

export const useIsSameHousehold = () => {
    const { control } = useFormContext<ApplicantCreation>();
    return useWatch({ control, name: 'wohnsituation.gemeinsamerHaushalt' }) === true;
};
